
export default {
  isAuthenticated: state => !!state.accessToken,
  accessToken: state => state.accessToken,
  tokenType: state => state.tokenType,
  getUser: state => state.user,
  getName: state => state.user.name,
  getFromApps: state => !!state.fromApps,
  getUserSocial: state => state.userSocial,
};



// WEBPACK FOOTER //
// ./src/stores/Auth/getters/index.js